// @ts-nocheck
import React, { useState } from 'react';
import { Checkbox, ListItemButton, Tooltip, Typography, tabClasses } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import WarningIcon from '@mui/icons-material/Warning';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import Moment from 'react-moment';
import {
	capitalizeTitle,
	extractAvatarFromContactProviderData,
	generateInitialsHelper,
} from '@src/helpers/Helpers';
import { handleDragOver } from '@src/helpers/FileHelper';
import {
	CALENDAR_SHORT,
	CHAT_KEY_PREFIX,
	CHAT_LIST_TAB_CASE_ALL,
	CHAT_LIST_TAB_CASE_GROUP,
	CHAT_LIST_TAB_CASE_ME,
	RESTAURANT,
} from '@src/Constants';
import ChatMessageShortContent from '../Main/Chat/ChatMessage/ChatMessageShortContent';
import { addPlus } from '@src/helpers/PhoneNumberHelper';
import { useTranslation } from 'react-i18next';
import PrintMessage from '../PrintMessage';
import CustomAvatar from '@src/components/CustomAvatar';
import SellIcon from '@mui/icons-material/Sell';
import useChatListItem from '@src/components/ChatListItem/useChatListItem';
import styles from './ChatListItem.module.css';
import classNames from 'classnames/bind';
import AssigneeChip from '@src/components/AssigneeChip';
import CustomCheckbox from '../Checkbox/CustomCheckbox';
import { useAppDispatch, useAppSelector } from '@src/store/hooks';
import { addChats } from '@src/store/reducers/chatsReducer';
import CustomDialog from '../CustomDialog/CustomDialog';
import { updateHiddenContacts } from '@src/api/SudoApiService';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import ChatMessageModel from '@src/api/models/ChatMessageModel';
import { ALL_PERMISSION_MAP, checkPermission } from '@src/helpers/Permission';
import CustomTooltip from '../CustomTootip/CustomTooltip';
import usePermission from '@src/hooks/usePermission';
import { IsMobileWidth } from '../MediaQueryUtils';

const OrderLastMessage = styled.div`
	font-size: 13px;
	font-weight: 500;
	color: '#5C5C5C';
`;

const cx = classNames.bind(styles);

const ChatListItem = (props) => {
	const { currentUser, permissions }: any = useAppSelector((state) => state?.currentUser);
	const { t } = useTranslation();
	const dispatch = useAppDispatch();

	const [confirmDialog, setConfirmDialog] = useState(false);
	const [disable, setDisable] = useState(false);
	const [hideChats, setHideChats] = useState('');

	const { customer } = props?.chatData || {};
	const { telephone } = customer || {};

	const handleChange = (e) => {
		let updatedChats = Object.entries(props?.chats)?.map((chat) => {
			if (chat[1]?.waId === props?.chatData?.waId) {
				chat[1].isHide = !chat[1]?.isHide;
			}
			return chat;
		});

		if (e.target.checked) {
			if (props?.tabCase === 'spam') {
				props?.setTempUnSpamChats([...props?.tempUnSpamChats, props?.chatData?.waId]);
			} else {
				props?.setTempSpamChats([...props?.tempSpamChats, props?.chatData?.waId]);
			}
		} else {
			if (props?.tabCase === 'spam') {
				let chats = props?.tempUnSpamChats?.filter((waid) => waid !== props?.chatData?.waId);
				props?.setTempUnSpamChats(chats);
			} else {
				let chats = props?.tempSpamChats?.filter((waid) => waid !== props?.chatData?.waId);
				props?.setTempSpamChats(chats);
			}
		}

		// Revert back to the original object format
		let revertedChats = Object.fromEntries(updatedChats);
		props?.setSelectAll(false);
		dispatch(addChats(revertedChats));
	};

	const handleNo = () => {
		setConfirmDialog(false);
		setHideChats('');
	};

	const handleYes = async () => {
		try {
			props?.setLoadingChats(true);
			setDisable(true);
			let updatedChats = Object.entries(props?.chats)?.map((chat) => {
				if (chat[1]?.waId === hideChats) {
					chat[1].isHide = !chat[1]?.isHide;
				}
				return chat;
			});

			let allSpamChats = props?.spamChats?.filter((waId) => waId !== hideChats);

			// Revert back to the original object format
			let revertedChats = Object.fromEntries(updatedChats);

			const data = {
				contacts: [hideChats],
				hidden: false,
			};
			await updateHiddenContacts(data);

			dispatch(addChats(revertedChats));
			props?.setSpamChats(allSpamChats);
			setConfirmDialog(false);
			setHideChats('');
			props?.setLoadingChats(false);
			setDisable(false);
		} catch (err) {
			props?.setError('Something went wrong! please try agin');
			props?.setLoadingChats(false);
			setDisable(false);
		}
	};

	const {
		data,
		id,
		waId,
		isExpired,
		timeLeft,
		remainingSeconds,
		isSelected,
		handleClick,
		handleDroppedFiles,
		generateTagNames,
		isDisabled,
		hasFailedMessages,
	} = useChatListItem({ props });

	//Permissions
	const checkPermission = usePermission();
	const chatView = checkPermission(ALL_PERMISSION_MAP?.GENERAL?.CHAT?.VIEW, data?.waId);
	const receiveMessagePermission = checkPermission(
		ALL_PERMISSION_MAP?.GENERAL?.MESSAGE?.RECEIVE,
		data?.waId
	);

	//For red spot alert in chats
	let newMessages = props?.newMessages[CHAT_KEY_PREFIX + data?.waId]?.newMessages;

	// if (currentUser?.type?.toLowerCase() === RESTAURANT) {
	// 	newMessages = props?.newMessages[CHAT_KEY_PREFIX + data?.waId]?.newMessages;
	// } else {
	// 	newMessages =
	// 		props?.newMessages[CHAT_KEY_PREFIX + data?.waId]?.newMessages;
	// }

	const isMobileWidth = IsMobileWidth();

	const handleChatClick = (e) => {
		if (e.target.id !== 'hide-chat') {
			handleClick();
		}
		if (data?.waId !== waId) {
			props?.setFieldBackField(null);
		}
	};

	const ischeckBoxChecked = () => {
		return props?.tabCase === 'spam' ? props?.chatData?.isHide : props?.chatData?.isHide;
	};
	const generateChatId = (type) => {
		// if (type === 'Restaurant') {
		// 	return waId === data.waId;
		// }
		// return id + waId === data?.restaurantId + data?.waId;
		return waId === data?.waId;
	};

	const getId = (type) => {
		// if (type === 'Restaurant') {
		// 	return data?.waId;
		// }
		// return data?.restaurantId + data?.waId;
		return data?.waId;
	};
	return (
		<>
			{confirmDialog ? (
				<CustomDialog
					open={confirmDialog}
					setConfirmModal={setConfirmDialog}
					disable={disable}
					description="Are you sure you want to unhide this chat"
					handleClose={handleNo}
					handleYes={handleYes}
				/>
			) : null}
			{chatView ? (
				<ListItemButton onClick={(e) => handleChatClick(e)} className={styles.listItem}>
					<div
						id={getId(currentUser?.type)}
						className={cx({
							wrapper: true,
							active: generateChatId(currentUser?.type),
							expired: isExpired,
							almostExpired: remainingSeconds < 8 * 60 * 60,
							selected: props.isSelectionModeEnabled && isSelected,
						})}
						onDrop={handleDroppedFiles}
						onDragOver={handleDragOver}
					>
						<div className={styles.item}>
							{props.isSelectionModeEnabled && (
								<Checkbox
									className={styles.selection}
									checked={isSelected}
									color="primary"
									disabled={isDisabled}
								/>
							)}
							{props?.hideChatOption ? (
								<CustomCheckbox
									id="hide-chat"
									isChecked={ischeckBoxChecked()}
									handleChange={(e) => handleChange(e)}
								/>
							) : null}
							<div className={styles.avatarWrapper}>
								<CustomAvatar
									className={styles.mainAvatar}
									src={data?.contact?.waba_payload?.profile?.photo}
									generateBgColorBy={!isExpired ? data?.companyName : undefined}
								>
									{data?.initials}
								</CustomAvatar>
							</div>

							<div className={styles.info}>
								<div className={styles.nameWrapper}>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
											minWidth: '100%',
										}}
									>
										<div
											style={{
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												maxWidth: '190px',
												color: '#333333',
												fontSize: '15px',
												fontWeight: 600,
											}}
										>
											<PrintMessage message={capitalizeTitle(data?.companyName)} />
										</div>
										{data.lastMessageTimestamp && (
											<Moment
												className={styles.lastMessageDate}
												date={data.lastMessageTimestamp}
												calendar={CALENDAR_SHORT}
												unix
											/>
										)}
									</div>

									{data.assignedToUser &&
										(props.tabCase === CHAT_LIST_TAB_CASE_ALL ||
											props.tabCase === CHAT_LIST_TAB_CASE_GROUP) && (
											<Tooltip placement="top" title={data.generateAssignmentInformation()}>
												<div>
													<AssigneeChip
														assigneeType={'user'}
														name={data.assignedToUser?.username}
													/>
												</div>
											</Tooltip>
										)}

									{data.assignedGroup &&
										((props.tabCase === CHAT_LIST_TAB_CASE_ALL && !data.assignedToUser) ||
											props.tabCase === CHAT_LIST_TAB_CASE_ME ||
											(props.tabCase === CHAT_LIST_TAB_CASE_GROUP && !data.assignedToUser)) && (
											<Tooltip placement="top" title={data.generateAssignmentInformation()}>
												<div>
													<AssigneeChip assigneeType={'group'} name={data.assignedGroup?.name} />
												</div>
											</Tooltip>
										)}
								</div>

								{telephone && (
									<div className={styles.telephone}>
										<Typography variant="body2" style={{ fontSize: '12px' }}>
											{telephone}
										</Typography>
									</div>
								)}

								{receiveMessagePermission ? (
									<div className={styles.lastMessageWrapper}>
										<div className={styles.lastMessage}>
											{data?.lastMessage?.type?.toLowerCase() === 'order' ? (
												<OrderLastMessage>
													New order# {data?.lastMessage?.order?.timeId}
												</OrderLastMessage>
											) : null}
											{data?.lastMessage?.type?.toLowerCase() ===
											ChatMessageModel.ORDER_FEEDBACK ? (
												<OrderLastMessage>
													Feedback on order# {data?.lastMessage?.orderFeedback?.timeId}
												</OrderLastMessage>
											) : null}
											{data?.lastMessageBody !== 'sudo-template-chat-init' ? (
												<ChatMessageShortContent
													type={data.lastMessageType}
													template={data.lastMessage?.template}
													buttonText={data.lastMessageButtonText}
													interactiveButtonText={data.interactiveButtonText}
													text={data.lastMessageBody}
													caption={data.lastMessageCaption}
													isLastMessageFromUs={data.isLastMessageFromUs}
													style={{
														fontSize: '13px !important',
														color: '#5C5C5C !important',
														fontWeight: 500,
													}}
												/>
											) : null}
										</div>
										{receiveMessagePermission && newMessages > 0 && (
											<div className={styles.newMessagesBadge}>
												{newMessages > 99 ? '99+' : newMessages}
											</div>
										)}

										{/* <div className={styles.dateTagWrapper}>
											{data.tags?.length > 0 && (
												<div className={styles.tags}>
													<Tooltip title={generateTagNames()}>
														<div>
															{data.tags.slice(0, 3).map((tagItem, tagIndex) => (
																<SellIcon
																	key={tagIndex}
																	className={styles.tagIcon}
																	style={{
																		fill: tagItem.web_inbox_color,
																	}}
																/>
															))}
														</div>
													</Tooltip>
												</div>
											)}
										</div> */}
									</div>
								) : null}
							</div>
						</div>

						<span className={styles.waId}>{data.waId}</span>

						{hasFailedMessages() && (
							<div className={styles.failedMessagesIndicator}>
								<Tooltip title={t('This chat has failed messages!')}>
									<WarningIcon className="error" />
								</Tooltip>
							</div>
						)}
					</div>
				</ListItemButton>
			) : (
				<CustomTooltip title="You don't have permission to view chat" placement="top">
					<ListItemButton onClick={(e) => {}} className={styles.listItem}>
						<div
							id={getId(currentUser?.type)}
							className={cx({
								wrapper: true,
								active: generateChatId(currentUser?.type),
								expired: isExpired,
								almostExpired: remainingSeconds < 8 * 60 * 60,
								selected: props.isSelectionModeEnabled && isSelected,
							})}
							onDrop={handleDroppedFiles}
							onDragOver={handleDragOver}
						>
							<div className={styles.item}>
								{props.isSelectionModeEnabled && (
									<Checkbox
										className={styles.selection}
										checked={isSelected}
										color="primary"
										disabled={isDisabled}
									/>
								)}
								{props?.hideChatOption ? (
									<CustomCheckbox
										id="hide-chat"
										isChecked={ischeckBoxChecked()}
										handleChange={(e) => handleChange(e)}
									/>
								) : null}
								<div className={styles.avatarWrapper}>
									<CustomAvatar
										className={styles.mainAvatar}
										src={data?.contact?.waba_payload?.profile?.photo}
										generateBgColorBy={!isExpired ? data?.companyName : undefined}
									>
										{data?.initials}
									</CustomAvatar>
								</div>

								<div className={styles.info}>
									<div className={styles.nameWrapper}>
										<div
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
												minWidth: '100%',
											}}
										>
											<div
												style={{
													overflow: 'hidden',
													textOverflow: 'ellipsis',
													maxWidth: '190px',
													color: '#333333',
													fontSize: '15px',
													fontWeight: 600,
												}}
											>
												<PrintMessage message={capitalizeTitle(data?.companyName)} />
											</div>
											{data.lastMessageTimestamp && (
												<Moment
													className={styles.lastMessageDate}
													date={data.lastMessageTimestamp}
													calendar={CALENDAR_SHORT}
													unix
												/>
											)}
										</div>

										{data.assignedToUser &&
											(props.tabCase === CHAT_LIST_TAB_CASE_ALL ||
												props.tabCase === CHAT_LIST_TAB_CASE_GROUP) && (
												<Tooltip placement="top" title={data.generateAssignmentInformation()}>
													<div>
														<AssigneeChip
															assigneeType={'user'}
															name={data.assignedToUser?.username}
														/>
													</div>
												</Tooltip>
											)}

										{data.assignedGroup &&
											((props.tabCase === CHAT_LIST_TAB_CASE_ALL && !data.assignedToUser) ||
												props.tabCase === CHAT_LIST_TAB_CASE_ME ||
												(props.tabCase === CHAT_LIST_TAB_CASE_GROUP && !data.assignedToUser)) && (
												<Tooltip placement="top" title={data.generateAssignmentInformation()}>
													<div>
														<AssigneeChip assigneeType={'group'} name={data.assignedGroup?.name} />
													</div>
												</Tooltip>
											)}
									</div>

									{telephone && (
										<div className={styles.telephone}>
											<Typography variant="body2" style={{ fontSize: '12px' }}>
												{telephone}
											</Typography>
										</div>
									)}

									{receiveMessagePermission ? (
										<div className={styles.lastMessageWrapper}>
											<div className={styles.lastMessage}>
												{data?.lastMessage?.type?.toLowerCase() === 'order' ? (
													<OrderLastMessage>
														New order# {data?.lastMessage?.order?.timeId}
													</OrderLastMessage>
												) : null}
												{data?.lastMessage?.type?.toLowerCase() ===
												ChatMessageModel.ORDER_FEEDBACK ? (
													<OrderLastMessage>
														Feedback on order# {data?.lastMessage?.orderFeedback?.timeId}
													</OrderLastMessage>
												) : null}
												{data?.lastMessageBody !== 'sudo-template-chat-init' ? (
													<ChatMessageShortContent
														type={data.lastMessageType}
														template={data.lastMessage?.template}
														buttonText={data.lastMessageButtonText}
														interactiveButtonText={data.interactiveButtonText}
														text={data.lastMessageBody}
														caption={data.lastMessageCaption}
														isLastMessageFromUs={data.isLastMessageFromUs}
														style={{
															fontSize: '13px !important',
															color: '#5C5C5C !important',
															fontWeight: 500,
														}}
													/>
												) : null}
											</div>
											{receiveMessagePermission && newMessages > 0 && (
												<div className={styles.newMessagesBadge}>
													{newMessages > 99 ? '99+' : newMessages}
												</div>
											)}

											{/* <div className={styles.dateTagWrapper}>
											{data.tags?.length > 0 && (
												<div className={styles.tags}>
													<Tooltip title={generateTagNames()}>
														<div>
															{data.tags.slice(0, 3).map((tagItem, tagIndex) => (
																<SellIcon
																	key={tagIndex}
																	className={styles.tagIcon}
																	style={{
																		fill: tagItem.web_inbox_color,
																	}}
																/>
															))}
														</div>
													</Tooltip>
												</div>
											)}
										</div> */}
										</div>
									) : null}
								</div>
							</div>

							<span className={styles.waId}>{data.waId}</span>

							{hasFailedMessages() && (
								<div className={styles.failedMessagesIndicator}>
									<Tooltip title={t('This chat has failed messages!')}>
										<WarningIcon className="error" />
									</Tooltip>
								</div>
							)}
						</div>
					</ListItemButton>
				</CustomTooltip>
			)}
		</>
	);
};

export default ChatListItem;
